import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NpFcvErrorComponent, NpFcvNameDirective } from '@newpla/common';
import { NpxCommonModule } from './npx-common.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { NpMultiCheckboxComponent } from '@newpla/ng-common';

const modules = [
  NpxCommonModule,
  FormsModule, ReactiveFormsModule,
  WjInputModule,
  NpFcvNameDirective, NpFcvErrorComponent, NpMultiCheckboxComponent
];

@NgModule({
  declarations: [],
  imports: [modules],
  exports: [modules]
})
export class NpxFormsModule { }
